export class BuildInfo {
  buildName: string;
  buildVersion: string;
  buildTime: Date;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      this.buildTime = new Date(this.buildTime);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/BuildInfo.ts